import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export const BunkerPriceChart = ({ data, theme }) => {
  // Transform data for chart (group by date and fuel type)
  const chartData = React.useMemo(() => {
    if (!data || data.length === 0) return [];
    
    // For now, just show latest prices by port
    const byPort = {};
    data.forEach(item => {
      if (!byPort[item.port_locode]) {
        byPort[item.port_locode] = {
          port: item.port_locode,
          VLSFO: 0,
          MGO: 0,
          HSFO: 0
        };
      }
      byPort[item.port_locode][item.fuel_type] = item.price_usd_per_mt;
    });
    
    return Object.values(byPort);
  }, [data]);

  if (chartData.length === 0) {
    return (
      <Card data-testid="bunker-price-chart">
        <CardHeader>
          <CardTitle>Bunker Prices by Port</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-64 flex items-center justify-center text-[hsl(var(--muted-foreground))]">
            No data available
          </div>
        </CardContent>
      </Card>
    );
  }

  const gridColor = theme === 'dark' ? 'hsl(215 16% 20%)' : 'hsl(213 18% 86%)';
  const textColor = theme === 'dark' ? 'hsl(0 0% 100%)' : 'hsl(216 20% 12%)';

  return (
    <Card data-testid="bunker-price-chart">
      <CardHeader>
        <CardTitle>Bunker Prices by Port (USD/MT)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
              <CartesianGrid stroke={gridColor} strokeDasharray="3 3" />
              <XAxis 
                dataKey="port" 
                tick={{ fontSize: 12, fill: textColor }} 
                stroke={gridColor}
              />
              <YAxis 
                tick={{ fontSize: 12, fill: textColor }} 
                stroke={gridColor}
              />
              <Tooltip 
                wrapperStyle={{ borderRadius: 8 }} 
                contentStyle={{ 
                  backgroundColor: theme === 'dark' ? 'hsl(220 15% 8%)' : 'hsl(0 0% 100%)', 
                  border: `1px solid ${gridColor}`,
                  borderRadius: 8,
                  color: textColor
                }} 
              />
              <Line 
                type="monotone" 
                dataKey="VLSFO" 
                stroke="hsl(187 60% 42%)" 
                strokeWidth={2} 
                dot={true}
                name="VLSFO"
              />
              <Line 
                type="monotone" 
                dataKey="MGO" 
                stroke="hsl(170 52% 60%)" 
                strokeWidth={2} 
                dot={true}
                name="MGO"
              />
              <Line 
                type="monotone" 
                dataKey="HSFO" 
                stroke="hsl(211 34% 28%)" 
                strokeWidth={2} 
                dot={true}
                name="HSFO"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};